import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    subject: '',
    domain: '',
  },
  goalbankSelection: {},
  curriculumSelection: {}
}

export const fluenciesUI = createSlice({
  name: 'fluenciesUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setSubject: (state, { payload }) => {
      state.tableFilters.subject = payload
    },
    setDomain: (state, { payload }) => {
      state.tableFilters.domain = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setSubject,
  setDomain,
  trackActiveFilters,
  clearAllFilters,
} = fluenciesUI.actions

export default fluenciesUI.reducer
